import { Routes, Route } from 'react-router-dom';
import { DashboardLayout, PublicLayout } from '@/components/layout';

// Test pages for layouts
function DashboardHome() {
  return (
    <div>
      <h1 className="font-display text-3xl font-bold text-gray-900 mb-4">Dashboard Home</h1>
      <p className="font-body text-gray-600">
        This is the dashboard home page using DashboardLayout with sidebar navigation.
      </p>
    </div>
  );
}

function BookingRequests() {
  return (
    <div>
      <h1 className="font-display text-3xl font-bold text-gray-900 mb-4">Booking Requests</h1>
      <p className="font-body text-gray-600">This page shows booking requests.</p>
    </div>
  );
}

function MyCalendar() {
  return (
    <div>
      <h1 className="font-display text-3xl font-bold text-gray-900 mb-4">Calendar</h1>
      <p className="font-body text-gray-600">This page shows your availability calendar.</p>
    </div>
  );
}

function MyBookings() {
  return (
    <div>
      <h1 className="font-display text-3xl font-bold text-gray-900 mb-4">My Bookings</h1>
      <p className="font-body text-gray-600">This page shows your confirmed bookings.</p>
    </div>
  );
}

function PublicHome() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="font-display text-4xl font-bold text-gray-900 mb-6">Welcome to CareCal</h1>
      <p className="font-body text-lg text-gray-600 mb-8">
        This is a public page using PublicLayout with header and footer.
      </p>
      <div className="bg-white rounded-lg p-6 shadow-sm border border-blush-200">
        <h2 className="font-display text-2xl font-semibold text-gray-900 mb-4">Layout Features</h2>
        <ul className="font-body text-gray-600 space-y-2">
          <li>✓ Responsive header with logo and auth buttons</li>
          <li>✓ Footer with links and copyright</li>
          <li>✓ Mobile-friendly design</li>
          <li>✓ Consistent spacing and styling</li>
        </ul>
      </div>
    </div>
  );
}

export default function LayoutTest() {
  return (
    <Routes>
      {/* Public routes */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<PublicHome />} />
      </Route>

      {/* Dashboard routes */}
      <Route path="/dashboard" element={<DashboardLayout />}>
        <Route index element={<DashboardHome />} />
        <Route path="booking-requests" element={<BookingRequests />} />
        <Route path="calendar" element={<MyCalendar />} />
        <Route path="bookings" element={<MyBookings />} />
      </Route>
    </Routes>
  );
}
